
    <div class="content" #context>
      <ng-content></ng-content>
    </div>
  